import { AccountInfo, AuthenticationResult, EventType, PublicClientApplication } from '@azure/msal-browser';
import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { msalConfig } from './config/authConfig';
import './index.css';
import reportWebVitals from './reportWebVitals';

/**
 * MSAL should be instantiated outside of the component tree to prevent it from being re-instantiated on re-renders.
 */
const msalInstance = new PublicClientApplication(msalConfig);

// Default to using the first account if no account is active on page load
if (!msalInstance.getActiveAccount() && msalInstance.getAllAccounts().length > 0) {
    const accounts = msalInstance.getAllAccounts();
    
    // TODO: decide how to handle multiple accounts
    if (accounts.length > 0) {
        msalInstance.setActiveAccount(accounts[0]);
    }
}

// Listen for sign-in event and set active account
msalInstance.addEventCallback((event) => {
    console.log(event)
    if (event.eventType === EventType.LOGIN_SUCCESS && event.payload) {
        const payload = event.payload as AuthenticationResult;
        const account = payload.account as AccountInfo;
        msalInstance.setActiveAccount(account);
    }
});

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <App pca={msalInstance} />
);

reportWebVitals();
